import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';

class CuentaBancaria extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'cuenta-bancaria/one', saveUrl: 'cuenta-bancaria/save', backUrl: '/Catalogo/CuentasBancarias' },
      new Form([
        Form.Field('text', 'cuenta', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'cuenta_no', 'No. de Cuenta', '', [Validators.required], 8),
        Form.Field('text', 'cuenta_nombre', 'Descripcion', '', [Validators.required], 6),
        Form.Field('text', 'cuenta_ccont', 'Ccont', '', [Validators.required], 6),
        Form.Field('text', 'cuenta_rfc', 'RFC', '', [Validators.required], 6),
        Form.Field('select', 'id_banco', 'Banco', '', [Validators.required], 6),
      ], ['Guardar'], 'Cuenta Bancaria'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  formData = async (form) => {
    var Res = await Http.get('banco/all');

    if (!Res.error) {
      const bancos = Form.FieldOptions(form, 'id_banco', Res.data, 'id', 'banco_nombre');
      return bancos;
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(CuentaBancaria)
